/**
 * Try-On UI: Camera / Choose Photo, then call StyleUAI try-on API.
 * No blur / pose / garment validation.
 * Contact required before try-on; device limit 3 successful generations / day.
 */
(function () {
  var TRYON_DAILY_STATE_KEY = "br_tryon_daily_state";
  var TRYON_DAILY_LIMIT = 3;

  function getLocalDateKey() {
    var d = new Date();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
  }

  function createFreshDailyState() {
    return {
      date: getLocalDateKey(),
      generationCount: 0,
      contactSubmitted: false,
      contact: null,
    };
  }

  function clearTryOnDailyStorage() {
    try {
      localStorage.removeItem(TRYON_DAILY_STATE_KEY);
    } catch (e) {}
  }

  function readDailyState() {
    try {
      var today = getLocalDateKey();
      var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
      if (!raw) return createFreshDailyState();
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.date !== today) {
        clearTryOnDailyStorage();
        return createFreshDailyState();
      }
      var genCount = parseInt(parsed.generationCount, 10);
      if (isNaN(genCount) || genCount < 0) genCount = 0;
      var contact = null;
      if (parsed.contact && typeof parsed.contact === "object") {
        contact = {
          name: parsed.contact.name != null ? String(parsed.contact.name) : "",
          phone: parsed.contact.phone != null ? String(parsed.contact.phone) : "",
        };
      }
      return {
        date: today,
        generationCount: genCount,
        contactSubmitted: parsed.contactSubmitted === true,
        contact: contact,
      };
    } catch (e) {
      clearTryOnDailyStorage();
      return createFreshDailyState();
    }
  }

  function writeDailyState(state) {
    try {
      localStorage.setItem(TRYON_DAILY_STATE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function incrementSuccessfulGenerationCount() {
    var state = readDailyState();
    state.generationCount = (state.generationCount || 0) + 1;
    writeDailyState(state);
  }

  function persistContactSubmitted(payload) {
    if (!payload) return;
    var state = readDailyState();
    state.contactSubmitted = true;
    state.contact = {
      name: payload.name,
      phone: normalizePhoneDigits(payload.phone),
      countryCode: payload.countryCode || "",
      code: payload.code || "",
    };
    writeDailyState(state);
  }

  function normalizePhoneDigits(value, maxLen) {
    return String(value || "").replace(/\D/g, "").slice(0, maxLen != null ? maxLen : 15);
  }

  function getPhoneUtil() {
    if (!window.libphonenumber || !libphonenumber.PhoneNumberUtil) return null;
    return libphonenumber.PhoneNumberUtil.getInstance();
  }

  function getDialCodeForRegion(isoCode) {
    var util = getPhoneUtil();
    if (!util || !isoCode) return "";
    try {
      return String(util.getCountryCodeForRegion(String(isoCode).toUpperCase()));
    } catch (e) {
      return "";
    }
  }

  function validatePhoneForRegion(nationalNumber, regionCode) {
    var digits = normalizePhoneDigits(nationalNumber);
    if (!digits) return false;
    var util = getPhoneUtil();
    if (!util) {
      if (String(regionCode || "").toUpperCase() === "IN") {
        return /^[6-9]\d{9}$/.test(digits);
      }
      return digits.length >= 6 && digits.length <= 15;
    }
    try {
      var region = String(regionCode || "IN").toUpperCase();
      var parsed = util.parse(String(digits), region);
      return util.isValidNumberForRegion(parsed, region);
    } catch (e) {
      return false;
    }
  }

  function formatPhoneE164(nationalNumber, regionCode) {
    var digits = normalizePhoneDigits(nationalNumber);
    if (!digits) return "";
    var util = getPhoneUtil();
    var region = String(regionCode || "IN").toUpperCase();
    if (!util) {
      var dial = getDialCodeForRegion(region) || (region === "IN" ? "91" : "");
      return dial ? "+" + dial + digits : digits;
    }
    try {
      var parsed = util.parse(String(digits), region);
      return util.format(parsed, libphonenumber.PhoneNumberFormat.E164);
    } catch (e) {
      return "";
    }
  }

  function getRegionDisplayName(isoCode, displayNames) {
    var iso = String(isoCode || "").toUpperCase();
    if (!iso) return "";
    if (displayNames) {
      try {
        var label = displayNames.of(iso);
        if (label && label !== iso) return label;
      } catch (e) {}
    }
    return iso;
  }

  function regionsToArray(regions) {
    if (!regions) return [];
    if (Array.isArray(regions)) return regions;
    if (typeof regions.length === "number") return Array.prototype.slice.call(regions);
    var list = [];
    if (typeof regions.forEach === "function") {
      regions.forEach(function (region) {
        list.push(region);
      });
    }
    return list;
  }

  function buildPhoneCountrySelect(selectEl) {
    if (!selectEl || selectEl.dataset.tryonCountriesBuilt === "true") return !!selectEl;

    var defaultIso = String(selectEl.getAttribute("data-default-country") || "IN").toUpperCase();
    var util = getPhoneUtil();
    var displayNames = null;
    try {
      if (typeof Intl !== "undefined" && Intl.DisplayNames) {
        displayNames = new Intl.DisplayNames(["en"], { type: "region" });
      }
    } catch (e) {
      displayNames = null;
    }

    var all = [];
    if (util) {
      regionsToArray(util.getSupportedRegions()).forEach(function (iso) {
        iso = String(iso || "").toUpperCase();
        var dial = getDialCodeForRegion(iso);
        if (!dial) return;
        all.push({ iso: iso, dial: dial, name: getRegionDisplayName(iso, displayNames) });
      });
    } else {
      all = [
        { iso: "IN", dial: "91", name: "India" },
        { iso: "US", dial: "1", name: "United States" },
        { iso: "GB", dial: "44", name: "United Kingdom" },
        { iso: "AE", dial: "971", name: "United Arab Emirates" },
        { iso: "AU", dial: "61", name: "Australia" },
        { iso: "CA", dial: "1", name: "Canada" },
        { iso: "SG", dial: "65", name: "Singapore" },
      ];
    }

    all.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });

    selectEl.innerHTML = "";
    var popularIsos = [defaultIso, "IN", "US", "GB", "AE", "AU"].filter(function (code, index, arr) {
      return code && arr.indexOf(code) === index;
    });
    var byIso = {};
    all.forEach(function (item) {
      byIso[item.iso] = item;
    });

    function appendOption(item) {
      var opt = document.createElement("option");
      opt.value = item.iso;
      opt.textContent = "+" + item.dial + " " + item.name;
      opt.setAttribute("data-dial-code", item.dial);
      if (item.iso === defaultIso) opt.selected = true;
      return opt;
    }

    var popularGroup = document.createElement("optgroup");
    popularGroup.label = "Popular";
    popularIsos.forEach(function (iso) {
      if (byIso[iso]) popularGroup.appendChild(appendOption(byIso[iso]));
    });
    if (popularGroup.children.length) selectEl.appendChild(popularGroup);

    var allGroup = document.createElement("optgroup");
    allGroup.label = "All countries";
    all.forEach(function (item) {
      allGroup.appendChild(appendOption(item));
    });
    selectEl.appendChild(allGroup);

    if (!selectEl.value) selectEl.value = defaultIso;
    selectEl.dataset.tryonCountriesBuilt = "true";
    return true;
  }

  function ensureBackdrop() {
    var el = document.querySelector(".br-tryon-page-backdrop");
    if (el) return el;
    el = document.createElement("div");
    el.className = "br-tryon-page-backdrop";
    document.body.appendChild(el);
    return el;
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  function stripDataUrlToRawBase64(dataUrl) {
    if (!dataUrl || typeof dataUrl !== "string") return "";
    var parts = dataUrl.split(",");
    return parts.length > 1 ? parts.slice(1).join(",") : dataUrl;
  }

  function dataUrlToBlob(value) {
    if (!value || typeof value !== "string") return null;
    var normalized = value.trim();
    if (!normalized) return null;
    if (normalized.indexOf("data:") !== 0) {
      normalized = "data:image/jpeg;base64," + normalized;
    }
    var parts = normalized.split(",");
    if (parts.length < 2) return null;
    var header = parts[0];
    var base64 = parts.slice(1).join(",");
    var mimeMatch = header.match(/data:(.*?);base64/);
    var mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : "image/jpeg";
    var binary = atob(base64);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
  }

  function imageFromUrl(imageUrl, useCrossOrigin) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      if (useCrossOrigin) image.crossOrigin = "anonymous";
      image.onload = function () {
        resolve(image);
      };
      image.onerror = function () {
        reject(new Error("Failed to decode image."));
      };
      image.src = imageUrl;
    });
  }

  function canvasToJpegBlob(canvasEl) {
    return new Promise(function (resolve) {
      canvasEl.toBlob(function (blob) {
        resolve(blob);
      }, "image/jpeg", 0.92);
    });
  }

  async function blobToJpegBase64(fileBlob) {
    var jpegBlob = fileBlob;
    var type = (fileBlob && fileBlob.type) || "";
    if (type.indexOf("jpeg") === -1 && type.indexOf("jpg") === -1) {
      var sourceUrl = URL.createObjectURL(fileBlob);
      try {
        var sourceImage = await imageFromUrl(sourceUrl);
        var tempCanvas = document.createElement("canvas");
        tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
        tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
        tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
        jpegBlob = await canvasToJpegBlob(tempCanvas);
      } finally {
        URL.revokeObjectURL(sourceUrl);
      }
    }
    var dataUrl = await blobToDataUrl(jpegBlob);
    return {
      base64: stripDataUrlToRawBase64(dataUrl),
      mimeType: "image/jpeg",
    };
  }

  async function imageUrlToJpegBase64(imageUrl) {
    var sourceImage;
    try {
      sourceImage = await imageFromUrl(imageUrl, true);
    } catch (e) {
      sourceImage = await imageFromUrl(imageUrl, false);
    }
    var tempCanvas = document.createElement("canvas");
    tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
    tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
    tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
    var jpegBlob = await canvasToJpegBlob(tempCanvas);
    var dataUrl = await blobToDataUrl(jpegBlob);
    return {
      base64: stripDataUrlToRawBase64(dataUrl),
      mimeType: "image/jpeg",
    };
  }

  function findDecodableImageFromJson(node, depth) {
    depth = depth || 0;
    if (!node || depth > 12) return null;
    if (typeof node === "string") {
      try {
        var blob = dataUrlToBlob(node);
        return blob && blob.size > 0 ? blob : null;
      } catch (e) {
        return null;
      }
    }
    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i += 1) {
        var fromArray = findDecodableImageFromJson(node[i], depth + 1);
        if (fromArray) return fromArray;
      }
      return null;
    }
    if (typeof node !== "object") return null;
    var preferredKeys = [
      "resultImageBase64",
      "result_image_base64",
      "image",
      "result_image",
      "image_base64",
      "result",
      "output",
      "data",
      "url",
      "image_url",
      "result_url",
    ];
    for (var k = 0; k < preferredKeys.length; k += 1) {
      if (node[preferredKeys[k]] != null) {
        var fromKey = findDecodableImageFromJson(node[preferredKeys[k]], depth + 1);
        if (fromKey) return fromKey;
      }
    }
    for (var key in node) {
      if (Object.prototype.hasOwnProperty.call(node, key)) {
        var nested = findDecodableImageFromJson(node[key], depth + 1);
        if (nested) return nested;
      }
    }
    return null;
  }

  async function parseTryonSuccessResponse(response) {
    var contentType = (response.headers.get("Content-Type") || "").toLowerCase();
    if (contentType.indexOf("image/") !== -1) {
      return response.blob();
    }
    var bodyText = await response.text();
    var data = null;
    try {
      data = JSON.parse(bodyText);
    } catch (e) {
      throw new Error("Try-on API returned a non-image, non-JSON response.");
    }
    if (data && data.success === false) {
      throw new Error(
        (data.error && (data.error.message || data.error)) || data.message || "Try-on failed."
      );
    }
    if (data && typeof data.resultImageBase64 === "string" && data.resultImageBase64.trim()) {
      var resultBlob = dataUrlToBlob(data.resultImageBase64);
      if (resultBlob && resultBlob.size > 0) return resultBlob;
      throw new Error("Try-on API returned an invalid result image.");
    }
    var blob = findDecodableImageFromJson(data);
    if (blob) return blob;
    var urlCandidate =
      data &&
      (data.result_url ||
        data.image_url ||
        data.url ||
        (data.output && (data.output.url || data.output.result_url)));
    if (urlCandidate && typeof urlCandidate === "string") {
      var imgRes = await fetch(urlCandidate);
      if (!imgRes.ok) throw new Error("Could not load generated image.");
      return imgRes.blob();
    }
    throw new Error("No result image in API response.");
  }

  function init(modal) {
    if (!modal || modal.dataset.ready === "true") return;
    modal.dataset.ready = "true";

    var backdrop = ensureBackdrop();
    var upload = modal.querySelector("[data-tryon-upload-trigger]");
    var video = modal.querySelector("[data-tryon-video]");
    var preview = modal.querySelector("[data-tryon-preview-image]");
    var resultImage = modal.querySelector("[data-tryon-result-image]");
    var canvas = modal.querySelector("[data-tryon-canvas]");
    var fileInput = modal.querySelector("[data-tryon-file]");
    var cameraBtn = modal.querySelector("[data-tryon-camera]");
    var chooseBtn = modal.querySelector("[data-tryon-choose]");
    var captureBtn = modal.querySelector("[data-tryon-capture-btn]");
    var flipBtn = modal.querySelector("[data-tryon-camera-flip]");
    var cameraError = modal.querySelector("[data-tryon-camera-error]");
    var statusEl = modal.querySelector("[data-tryon-status]");
    var loaderNode = modal.querySelector("[data-tryon-loader]");
    var loaderTextNode = modal.querySelector("[data-tryon-loader-text]");
    var detailsModal = modal.querySelector("[data-tryon-details-modal]");
    var detailsTitleEl = modal.querySelector("[data-tryon-details-title]");
    var detailsNameInput = modal.querySelector("[data-tryon-customer-name]");
    var detailsPhoneInput = modal.querySelector("[data-tryon-customer-phone]");
    var detailsPhoneCountry = modal.querySelector("[data-tryon-phone-country]");
    var detailsConsentInput = modal.querySelector("[data-tryon-consent]");
    var detailsErrorEl = modal.querySelector("[data-tryon-details-error]");
    var detailsSubmitButton = modal.querySelector("[data-tryon-details-submit]");
    var detailsCancelButton = modal.querySelector("[data-tryon-details-cancel]");
    var downloadButton = modal.querySelector("[data-tryon-download]");
    var shareButton = modal.querySelector("[data-tryon-share]");
    var regenerateButton = modal.querySelector("[data-tryon-regenerate]");

    var stream = null;
    var objectUrl = null;
    var resultObjectUrl = null;
    var generatedBlob = null;
    var generatedFilename = "try-on-result.jpg";
    var lastSourceBlob = null;
    var lastInputMode = "";
    var facingMode = "user";
    var isLoading = false;
    var loadingTextInterval = null;
    var dailyLimit = parseInt(modal.dataset.tryonDailyLimit || TRYON_DAILY_LIMIT, 10);
    if (isNaN(dailyLimit) || dailyLimit < 1) dailyLimit = TRYON_DAILY_LIMIT;
    var loadingMessages = [
      "Preparing your try-on...",
      "Fitting the garment...",
      "Almost ready...",
    ];

    function setStatus(msg, variant) {
      if (!statusEl) return;
      statusEl.textContent = msg || "";
      if (variant === "error") statusEl.classList.add("br-tryon-status--error");
      else statusEl.classList.remove("br-tryon-status--error");
    }

    function setError(msg) {
      if (cameraError) cameraError.textContent = msg || "";
    }

    function setDetailsError(msg) {
      if (detailsErrorEl) detailsErrorEl.textContent = msg || "";
    }

    function setInputErrorState(input, hasError) {
      if (!input) return;
      if (hasError) input.classList.add("br-tryon-input-error");
      else input.classList.remove("br-tryon-input-error");
    }

    function submitToGoogleSheet(url, bodyObj) {
      var body = JSON.stringify(bodyObj);
      return fetch(url, {
        method: "POST",
        mode: "no-cors",
        cache: "no-store",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: body,
      })
        .then(function () {})
        .catch(function (error) {
          console.error("[TryOn] Sheet submit failure:", error && error.message ? error.message : error);
        });
    }

    function getSelectedPhoneRegion() {
      if (!detailsPhoneCountry || !detailsPhoneCountry.value) {
        return String((detailsPhoneCountry && detailsPhoneCountry.getAttribute("data-default-country")) || "IN").toUpperCase();
      }
      return String(detailsPhoneCountry.value).toUpperCase();
    }

    function getSelectedDialCode() {
      if (!detailsPhoneCountry) return "";
      var selected = detailsPhoneCountry.options[detailsPhoneCountry.selectedIndex];
      if (selected && selected.getAttribute("data-dial-code")) {
        return String(selected.getAttribute("data-dial-code"));
      }
      return getDialCodeForRegion(getSelectedPhoneRegion()) || "";
    }

    function submitCustomerDetails(payload) {
      var url = (modal.dataset.detailsEndpoint || "").trim();
      if (!url || !payload) {
        console.warn("[TryOn] Sheet submit skipped: missing endpoint or payload.");
        return Promise.resolve();
      }
      var dialCode = String(payload.code || "")
        .trim()
        .replace(/^\+/, "");
      if (!dialCode) {
        dialCode = getDialCodeForRegion(payload.countryCode || "") || "";
      }
      var nationalPhone = normalizePhoneDigits(payload.phone);
      var phoneE164 = String(payload.phoneE164 || "").trim();
      if (!phoneE164 && dialCode && nationalPhone) {
        phoneE164 = "+" + dialCode + nationalPhone;
      }
      // Separate columns: code = "+91", phone = national digits only.
      // Leading ' on code stops Sheets from treating + as a formula.
      var codeForSheet = dialCode ? "'+" + dialCode : "";
      var bodyObj = {
        name: String(payload.name || "").trim(),
        code: codeForSheet,
        phone: nationalPhone,
        phoneNational: nationalPhone,
        phoneE164: phoneE164,
        countryCode: String(payload.countryCode || "").trim(),
        consent: payload.consent === true,
        productName: (modal.dataset.tryonProductName || "").trim(),
        productUrl: (modal.dataset.tryonProductUrl || "").trim(),
      };
      return submitToGoogleSheet(url, bodyObj);
    }

    function askCustomerDetails() {
      if (!detailsModal || !detailsNameInput || !detailsPhoneInput || !detailsSubmitButton || !detailsCancelButton) {
        return Promise.resolve(null);
      }

      return new Promise(function (resolve) {
        var isSubmitting = false;

        function setDetailsBusy(busy) {
          isSubmitting = !!busy;
          detailsSubmitButton.disabled = !!busy;
          detailsCancelButton.disabled = !!busy;
          if (detailsPhoneCountry) detailsPhoneCountry.disabled = !!busy;
          if (detailsConsentInput) detailsConsentInput.disabled = !!busy;
          if (busy) detailsSubmitButton.classList.add("is-busy");
          else detailsSubmitButton.classList.remove("is-busy");
          detailsModal.setAttribute("data-submit-busy", busy ? "true" : "false");
        }

        function closePopup(result) {
          setDetailsBusy(false);
          detailsModal.hidden = true;
          modal.classList.remove("br-tryon-modal--details-open");
          detailsSubmitButton.removeEventListener("click", submitHandler);
          detailsCancelButton.removeEventListener("click", cancelHandler);
          detailsPhoneInput.removeEventListener("input", phoneInputHandler);
          if (detailsPhoneCountry) {
            detailsPhoneCountry.removeEventListener("change", countryChangeHandler);
          }
          resolve(result);
        }

        function phoneInputHandler() {
          detailsPhoneInput.value = normalizePhoneDigits(detailsPhoneInput.value);
          setInputErrorState(detailsPhoneInput, false);
          if (detailsPhoneCountry) setInputErrorState(detailsPhoneCountry, false);
          setDetailsError("");
        }

        function countryChangeHandler() {
          setInputErrorState(detailsPhoneInput, false);
          if (detailsPhoneCountry) setInputErrorState(detailsPhoneCountry, false);
          setDetailsError("");
        }

        function submitHandler() {
          if (isSubmitting) return;

          var name = (detailsNameInput.value || "").trim();
          var phoneRegion = getSelectedPhoneRegion();
          var phone = normalizePhoneDigits(detailsPhoneInput.value);
          detailsPhoneInput.value = phone;
          var dialCode = getSelectedDialCode();
          var phoneE164 = formatPhoneE164(phone, phoneRegion);
          var missingName = !name;
          var missingPhone = !phone;
          var invalidPhone = !validatePhoneForRegion(phone, phoneRegion) || !phoneE164;
          var consentGiven = !!(detailsConsentInput && detailsConsentInput.checked);

          setInputErrorState(detailsNameInput, missingName);
          setInputErrorState(detailsPhoneInput, missingPhone || invalidPhone);
          if (detailsPhoneCountry) {
            setInputErrorState(detailsPhoneCountry, missingPhone || invalidPhone);
          }

          if (missingName || missingPhone) {
            setDetailsError("Please enter both name and mobile number.");
            return;
          }
          if (invalidPhone) {
            setDetailsError("Enter a valid mobile number for the selected country.");
            return;
          }
          if (!consentGiven) {
            setDetailsError("Please give consent for raagadesai team to contact.");
            return;
          }

          setDetailsError("");
          setDetailsBusy(true);
          var payload = {
            name: name,
            phone: phone,
            code: dialCode,
            countryCode: phoneRegion,
            phoneE164: phoneE164,
            consent: true,
          };
          persistContactSubmitted(payload);
          submitCustomerDetails(payload).finally(function () {
            closePopup(payload);
          });
        }

        function cancelHandler() {
          if (isSubmitting) return;
          closePopup(null);
        }

        buildPhoneCountrySelect(detailsPhoneCountry);
        var state = readDailyState();
        detailsNameInput.value = (state.contact && state.contact.name) || "";
        detailsPhoneInput.value = normalizePhoneDigits((state.contact && state.contact.phone) || "");
        if (detailsPhoneCountry) {
          var savedCountry =
            (state.contact && state.contact.countryCode) ||
            detailsPhoneCountry.getAttribute("data-default-country") ||
            "IN";
          detailsPhoneCountry.value = String(savedCountry).toUpperCase();
        }
        if (detailsConsentInput) detailsConsentInput.checked = false;
        setInputErrorState(detailsNameInput, false);
        setInputErrorState(detailsPhoneInput, false);
        if (detailsPhoneCountry) setInputErrorState(detailsPhoneCountry, false);
        setDetailsError("");
        setDetailsBusy(false);
        if (detailsTitleEl) {
          detailsTitleEl.textContent = "Enter your details to start try-on";
        }
        if (detailsSubmitButton) detailsSubmitButton.textContent = "Continue";
        detailsModal.hidden = false;
        modal.classList.add("br-tryon-modal--details-open");
        detailsSubmitButton.addEventListener("click", submitHandler);
        detailsCancelButton.addEventListener("click", cancelHandler);
        detailsPhoneInput.addEventListener("input", phoneInputHandler);
        if (detailsPhoneCountry) {
          detailsPhoneCountry.addEventListener("change", countryChangeHandler);
        }
        setStatus("Enter your name and phone to continue.");
        detailsNameInput.focus();
      });
    }

    async function ensureContactForTryOn() {
      var state = readDailyState();
      if (state.contactSubmitted) return true;
      var details = await askCustomerDetails();
      if (!details) {
        setStatus("Name and phone are required to start try-on.");
        return false;
      }
      return true;
    }

    function canGenerateToday() {
      var state = readDailyState();
      return (state.generationCount || 0) < dailyLimit;
    }

    function setLoading(value) {
      isLoading = !!value;
      if (upload) upload.setAttribute("data-loading", value ? "true" : "false");
      if (loaderNode) loaderNode.setAttribute("aria-hidden", value ? "false" : "true");
      if (loadingTextInterval) {
        clearInterval(loadingTextInterval);
        loadingTextInterval = null;
      }
      if (!loaderTextNode) return;
      if (value) {
        var messageIndex = 0;
        loaderTextNode.textContent = loadingMessages[messageIndex];
        loadingTextInterval = setInterval(function () {
          messageIndex = (messageIndex + 1) % loadingMessages.length;
          loaderTextNode.textContent = loadingMessages[messageIndex];
        }, 1400);
      } else {
        loaderTextNode.textContent = loadingMessages[0];
      }
    }

    function stopCamera() {
      if (stream) {
        stream.getTracks().forEach(function (t) {
          t.stop();
        });
        stream = null;
      }
      if (video) video.srcObject = null;
    }

    function revokeUrl() {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
    }

    function revokeResultUrl() {
      if (resultObjectUrl) {
        URL.revokeObjectURL(resultObjectUrl);
        resultObjectUrl = null;
      }
    }

    function setState(state) {
      if (!upload) return;
      if (state) upload.setAttribute("data-state", state);
      else upload.removeAttribute("data-state");
      if (state !== "camera") stopCamera();
    }

    function resetSession() {
      stopCamera();
      revokeUrl();
      revokeResultUrl();
      generatedBlob = null;
      lastSourceBlob = null;
      lastInputMode = "";
      generatedFilename = "try-on-result.jpg";
      setLoading(false);
      if (preview) {
        preview.removeAttribute("src");
        preview.removeAttribute("srcset");
      }
      if (resultImage) {
        resultImage.removeAttribute("src");
        resultImage.removeAttribute("srcset");
      }
      if (fileInput) fileInput.value = "";
      if (canvas) {
        var ctx = canvas.getContext("2d");
        if (ctx && canvas.width && canvas.height) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
      setState("");
      setError("");
      setStatus("Choose camera or upload to start try-on.");
    }

    function downloadBlob(blob, filename) {
      var fileUrl = URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = filename || "try-on-result.jpg";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      setTimeout(function () {
        URL.revokeObjectURL(fileUrl);
      }, 1000);
    }

    async function handleDownload() {
      if (isLoading) return;
      if (!generatedBlob) {
        setStatus("Generate image first.");
        return;
      }
      try {
        downloadBlob(generatedBlob, generatedFilename);
        setStatus("Downloaded.");
      } catch (err) {
        setStatus("Download failed.");
        console.error("[TryOn] Download error:", err);
      }
    }

    async function handleShare() {
      if (isLoading) return;
      if (!generatedBlob) {
        setStatus("Generate image first.");
        return;
      }
      var shareFile = new File([generatedBlob], generatedFilename, {
        type: generatedBlob.type || "image/jpeg",
      });
      if (navigator.canShare && navigator.canShare({ files: [shareFile] })) {
        try {
          await navigator.share({
            title: "Try-On Result",
            text: "Try-On Result",
            files: [shareFile],
          });
          setStatus("Shared successfully.");
        } catch (error) {
          if (error && error.name !== "AbortError") {
            setStatus("Share cancelled.");
          }
        }
      } else {
        try {
          downloadBlob(generatedBlob, generatedFilename);
          setStatus("Share unsupported. Downloaded instead.");
        } catch (err) {
          setStatus("Download failed.");
          console.error("[TryOn] Download error:", err);
        }
      }
    }

    async function handleRegenerate() {
      if (isLoading) return;
      if (!lastSourceBlob) {
        setStatus("Capture or upload first, then regenerate.");
        return;
      }
      await requestGeneration(lastSourceBlob);
    }

    function closeAnyZoomDialog() {
      document.querySelectorAll("zoom-dialog dialog[open]").forEach(function (dialog) {
        try {
          dialog.close();
        } catch (e) {}
      });
    }

    function open() {
      closeAnyZoomDialog();
      resetSession();
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      backdrop.classList.add("is-visible");
      document.documentElement.style.overflow = "hidden";
    }

    function close() {
      resetSession();
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      backdrop.classList.remove("is-visible");
      document.documentElement.style.overflow = "";
    }

    async function dataUrlToPersonBlob(dataUrl) {
      var res = await fetch(dataUrl);
      return res.blob();
    }

    function clearPendingCapturePreview() {
      revokeUrl();
      lastSourceBlob = null;
      if (preview) {
        preview.removeAttribute("src");
        preview.removeAttribute("srcset");
      }
      if (fileInput) fileInput.value = "";
      setError("");
    }

    async function restoreAfterContactCancel() {
      // Leave preview state before clearing src so an empty img never flashes.
      if (lastInputMode === "camera") {
        setState("camera");
        clearPendingCapturePreview();
        await startCamera();
        setStatus("Choose camera or upload to start try-on.");
        return;
      }
      setState("");
      clearPendingCapturePreview();
      setStatus("Choose camera or upload to start try-on.");
    }

    async function requestGeneration(personBlob) {
      if (isLoading) return;
      if (!canGenerateToday()) {
        setStatus("Daily limit reached.", "error");
        return;
      }
      var contactOk = await ensureContactForTryOn();
      if (!contactOk) {
        await restoreAfterContactCancel();
        return;
      }
      await sendToApi(personBlob);
    }

    async function sendToApi(personBlob) {
      if (isLoading) return;

      var endpoint = (modal.dataset.apiEndpoint || "").trim();
      var apiKey = (modal.dataset.apiKey || modal.dataset.apiAuth || "").trim();
      var garmentUrl = (modal.dataset.defaultGarment || "").trim();
      var prompt = (modal.dataset.tryonPrompt || "").trim();
      var resolution = String(modal.dataset.tryonResolution || "1K").trim().toUpperCase();
      if (resolution !== "1K" && resolution !== "2K" && resolution !== "4K") {
        resolution = "1K";
      }

      if (!endpoint) {
        setStatus("API endpoint missing.");
        return;
      }
      if (!apiKey) {
        setStatus("Add your API key to start try-on.");
        return;
      }
      if (!garmentUrl) {
        setStatus("Garment image missing.");
        return;
      }
      if (!personBlob) {
        setStatus("Person photo missing.");
        return;
      }

      if (!canGenerateToday()) {
        setStatus("Daily limit reached.", "error");
        return;
      }

      setError("");
      setStatus("Generating try-on...");
      setLoading(true);

      try {
        var personEncoded = await blobToJpegBase64(personBlob);
        var garmentEncoded = await imageUrlToJpegBase64(garmentUrl);
        if (!personEncoded.base64 || !garmentEncoded.base64) {
          throw new Error("Could not prepare model or garment image.");
        }

        var payload = {
          personImage: personEncoded.base64,
          garmentMimeType: garmentEncoded.mimeType || "image/jpeg",
          garmentImage: garmentEncoded.base64,
          resolution: resolution,
          prompt: prompt,
        };

        var abortController = new AbortController();
        var abortTimer = setTimeout(function () {
          abortController.abort();
        }, 600000);

        var response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": apiKey,
          },
          body: JSON.stringify(payload),
          signal: abortController.signal,
        });
        clearTimeout(abortTimer);

        if (!response.ok) {
          var errBodyText = "";
          try {
            errBodyText = await response.text();
          } catch (e) {}
          var errMsg = "Try-on failed (" + response.status + ").";
          try {
            var errJson = JSON.parse(errBodyText);
            errMsg =
              (errJson && (errJson.message || errJson.error || errJson.detail)) || errMsg;
            if (typeof errMsg === "object") {
              errMsg = errMsg.message || JSON.stringify(errMsg);
            }
          } catch (e2) {
            if (errBodyText) errMsg = errBodyText.slice(0, 180);
          }
          throw new Error(errMsg);
        }

        var apiResultBlob = await parseTryonSuccessResponse(response);
        if (!apiResultBlob) throw new Error("No result image in API response.");

        generatedBlob = apiResultBlob;
        generatedFilename = "try-on-" + Date.now() + ".jpg";
        revokeResultUrl();
        resultObjectUrl = URL.createObjectURL(apiResultBlob);
        if (resultImage) resultImage.src = resultObjectUrl;
        setState("result");
        incrementSuccessfulGenerationCount();
        setStatus("Try-on ready.");
      } catch (error) {
        var msg =
          error && error.name === "AbortError"
            ? "Request timed out. Please retry."
            : (error && error.message && String(error.message).trim()) ||
              "Try-on failed. Please retry.";
        setStatus(msg);
        console.error("[TryOn] error:", msg, error);
      } finally {
        setLoading(false);
      }
    }

    async function startCamera() {
      setError("");
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setError("Camera not supported. Please choose a photo.");
        return;
      }
      try {
        stopCamera();
        stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: facingMode,
            width: { ideal: 720 },
            height: { ideal: 1280 },
            aspectRatio: { ideal: 0.8 },
          },
        });
        video.srcObject = stream;
        await video.play();
        if (preview) preview.removeAttribute("src");
        setState("camera");
        setStatus("Choose camera or upload to start try-on.");
      } catch (e) {
        console.warn("[TryOn] camera", e);
        setError("Could not access camera. Allow permission, or choose a photo.");
        setState("");
      }
    }

    /** Match CSS object-fit: cover + object-position: center for the live preview box. */
    function getCoverCrop(sourceW, sourceH, displayW, displayH) {
      var sw = sourceW || 1;
      var sh = sourceH || 1;
      var dw = displayW > 0 ? displayW : sw;
      var dh = displayH > 0 ? displayH : sh;
      var sourceRatio = sw / sh;
      var displayRatio = dw / dh;
      var cropW;
      var cropH;
      var cropX;
      var cropY;
      if (sourceRatio > displayRatio) {
        cropH = sh;
        cropW = sh * displayRatio;
        cropX = (sw - cropW) / 2;
        cropY = 0;
      } else {
        cropW = sw;
        cropH = sw / displayRatio;
        cropX = 0;
        cropY = (sh - cropH) / 2;
      }
      return {
        sx: Math.max(0, cropX),
        sy: Math.max(0, cropY),
        sw: Math.max(1, cropW),
        sh: Math.max(1, cropH),
      };
    }

    async function capture() {
      if (!video || !canvas || !preview || !stream || isLoading) return;
      var w = video.videoWidth || 720;
      var h = video.videoHeight || 960;
      if (w < 2 || h < 2) return;

      var displayW = video.clientWidth || video.offsetWidth || w;
      var displayH = video.clientHeight || video.offsetHeight || h;
      var crop = getCoverCrop(w, h, displayW, displayH);

      // Keep captured pixels sharp while preserving the exact preview aspect.
      var outW = Math.round(crop.sw);
      var outH = Math.round(crop.sh);
      canvas.width = outW;
      canvas.height = outH;
      var ctx = canvas.getContext("2d");
      if (!ctx) return;
      ctx.drawImage(
        video,
        crop.sx,
        crop.sy,
        crop.sw,
        crop.sh,
        0,
        0,
        outW,
        outH
      );
      revokeUrl();
      var dataUrl = canvas.toDataURL("image/jpeg", 0.92);
      preview.src = dataUrl;
      setState("preview");
      stopCamera();
      var personBlob = await dataUrlToPersonBlob(dataUrl);
      lastInputMode = "camera";
      lastSourceBlob = personBlob;
      await requestGeneration(personBlob);
    }

    async function onFile(file) {
      if (!file || file.type.indexOf("image/") !== 0 || isLoading) return;
      revokeUrl();
      objectUrl = URL.createObjectURL(file);
      preview.src = objectUrl;
      setState("preview");
      setError("");
      lastInputMode = "upload";
      lastSourceBlob = file;
      await requestGeneration(file);
    }

    function stopTryOnOpenEvent(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
    }

    document.addEventListener(
      "pointerdown",
      function (event) {
        var trigger = event.target.closest("[data-tryon-open]");
        if (!trigger) return;
        stopTryOnOpenEvent(event);
      },
      true
    );

    document.addEventListener(
      "click",
      function (event) {
        var trigger = event.target.closest("[data-tryon-open]");
        if (!trigger) return;
        stopTryOnOpenEvent(event);
        open();
      },
      true
    );

    modal.querySelectorAll("[data-tryon-close]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        close();
      });
    });

    if (cameraBtn) {
      cameraBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        startCamera();
      });
    }

    if (chooseBtn) {
      chooseBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        stopCamera();
        if (preview) {
          preview.removeAttribute("src");
          preview.removeAttribute("srcset");
        }
        revokeUrl();
        setState("");
        setError("");
        setStatus("Choose camera or upload to start try-on.");
        if (fileInput) fileInput.click();
      });
    }

    if (upload) {
      upload.addEventListener("click", function (e) {
        if (e.target.closest("button")) return;
        if (upload.getAttribute("data-state") === "camera") return;
        if (isLoading) return;
        if (fileInput) fileInput.click();
      });
    }

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        if (fileInput.files && fileInput.files[0]) onFile(fileInput.files[0]);
      });
    }

    if (captureBtn) {
      captureBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        capture();
      });
    }

    if (flipBtn) {
      flipBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        facingMode = facingMode === "user" ? "environment" : "user";
        startCamera();
      });
    }

    if (downloadButton) {
      downloadButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleDownload();
      });
    }

    if (shareButton) {
      shareButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleShare();
      });
    }

    if (regenerateButton) {
      regenerateButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleRegenerate();
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-tryon-modal]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
